import { useState } from "react";

import data from "../data";
import { SEO } from "../components/SEO";
import WeveMoved from "../components/WatchLive/WeveMoved";
import USMap from "../components/WatchLive/USMap";
import SchoolGrid from "../components/WatchLive/Grid";

export function HomePage() {
  const [stateSelected, setStateSelected] = useState<string | null>(null);
  return (
    <>
      <SEO
        title="LocalLive - High School Sports Streaming"
        description="Watch live high school sports streams from schools across the United States. Find your school and watch games, matches, and events online."
        keywords="high school sports, live streaming, school sports, athletics, games, online streaming, LocalLive"
      />
      <section className="container mx-auto px-4">
        <WeveMoved />
        <USMap data={data} setStateSelected={setStateSelected} />
        <SchoolGrid
          data={data}
          stateSelected={stateSelected}
          setStateSelected={setStateSelected}
        />
      </section>
    </>
  );
}
